module.exports = __webpack_public_path__ + "static/media/aplicacao.c47c249b.png";